import { getSessionId, getAWBValue } from '../components/SessionStorage';
import { config } from './config/config';

const analyticsBase = () =>
  config.chatbotbackendapi.replace('/webhook', '/chat/session');

function analyticsHeaders() {
  return {
    'Content-Type': 'application/json',
    project: 'chatBot',
  };
}

function resolveShippingId(shippingId) {
  return shippingId || getAWBValue() || '';
}

export async function startSessionAnalytics({ shippingId = '', mobile_number = '' } = {}) {
  try {
    await fetch(`${analyticsBase()}/start`, {
      method: 'POST',
      headers: analyticsHeaders(),
      body: JSON.stringify({
        sessionId: getSessionId(),
        shippingId: resolveShippingId(shippingId),
        mobile_number: mobile_number || '',
      }),
      keepalive: true,
    });
  } catch (err) {
    console.error('[sessionAnalytics] start error:', err);
  }
}

export async function pingSessionAnalytics({ shippingId = '' } = {}) {
  try {
    await fetch(`${analyticsBase()}/ping`, {
      method: 'POST',
      headers: analyticsHeaders(),
      body: JSON.stringify({
        sessionId: getSessionId(),
        shippingId: resolveShippingId(shippingId),
      }),
      keepalive: true,
    });
  } catch (err) {
    console.error('[sessionAnalytics] ping error:', err);
  }
}

export async function endSessionAnalytics({
  endedReason = 'abandoned',
  shippingId = '',
  outcome,
} = {}) {
  try {
    const body = {
      sessionId: getSessionId(),
      shippingId: resolveShippingId(shippingId),
      endedReason,
    };
    if (outcome) {
      body.outcome = outcome;
    }
    await fetch(`${analyticsBase()}/end`, {
      method: 'POST',
      headers: analyticsHeaders(),
      body: JSON.stringify(body),
      keepalive: true,
    });
  } catch (err) {
    console.error('[sessionAnalytics] end error:', err);
  }
}

export function beaconEndSessionAnalytics({
  endedReason = 'abandoned',
  shippingId = '',
} = {}) {
  try {
    const payload = JSON.stringify({
      sessionId: getSessionId(),
      shippingId: resolveShippingId(shippingId),
      endedReason,
    });
    const url = `${analyticsBase()}/end`;
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      const blob = new Blob([payload], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
      return;
    }
    fetch(url, {
      method: 'POST',
      headers: analyticsHeaders(),
      body: payload,
      keepalive: true,
    }).catch(() => {});
  } catch (err) {
    console.error('[sessionAnalytics] beacon end error:', err);
  }
}
